import {createAction} from 'redux-actions'

export const startSavePGM = createAction('PGM/PROCESS/SAVE/START')
export const completeSavePGM = createAction('PGM/PROCESS/SAVE/COMPLETE')
export const failureSavePGM = createAction('PGM/PROCESS/SAVE/FAILURE')
export const disablePGM = createAction('PGM/PROCESS/DISABLE')
